'use strict';

var promisify = require('promisify-es6');

var cleanCID = require('../utils/clean-cid');

var TarStreamToObjects = require('../utils/tar-stream-to-objects');

var concat = require('concat-stream');

var through = require('through2');

var v = require('is-ipfs');

module.exports = function (send) {
  return promisify(function (path, opts, callback) {
    if (typeof opts === 'function' && !callback) {
      callback = opts;
      opts = {};
    } // opts is the real callback --
    // 'callback' is being injected by promisify


    if (typeof opts === 'function' && typeof callback === 'function') {
      callback = opts;
      opts = {};
    }

    try {
      path = cleanCID(path);
    } catch (err) {
      if (!v.ipfsPath(path)) {
        return callback(err);
      }
    }

    var request = {
      path: 'get',
      args: path,
      qs: opts // Convert the response stream to TarStream objects

    };
    send.andTransform(request, TarStreamToObjects, function (err, stream) {
      if (err) {
        return callback(err);
      }

      var files = [];
      stream.pipe(through.obj(function (file, enc, next) {
        if (file.content) {
          file.content.pipe(concat(function (content) {
            files.push({
              path: file.path,
              content: content
            });
          }));
        } else {
          files.push(file);
        }

        next();
      }, function () {
        return callback(null, files);
      }));
    });
  });
};